<template>
  <div>
    <DeleteLearningCenterModal
      :learning="toBeDeletedLearning"
      @deleted="fetchLearnings"
    />
    <b-card>
      <b-button
        v-if="$can('write', 'learning-center-management')"
        class="mb-1"
        variant="primary"
        to="/drivers/learning-center/new"
      >
        Create new learning
      </b-button>
      <b-overlay
        variant="white"
        spinner-variant="primary"
        blur="0"
        opacity=".75"
        rounded="sm"
        :show="loading"
      >
        <b-table
          fixed
          :fields="tableColumns"
          :items="learnings"
          class="mb-2 text-center"
          show-empty
          empty-text="No learnings yet"
          sort-by.sync="sort_order"
          :sort-desc.sync="sortDesc"
        >
          <template #cell(actions)="data">
            <b-dropdown
              v-if="$can('write', 'learning-center-management') || $can('delete', 'learning-center-management')"
              variant="link"
            >

              <template #button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="align-middle text-body"
                />
              </template>

              <b-dropdown-item
                v-if="$can('write', 'learning-center-management')"
                @click="$router.push(`/drivers/learning-center/${data.item.id}`)"
              >
                <feather-icon icon="EditIcon" />
                <span class="align-middle ml-50">Edit Learning</span>
              </b-dropdown-item>
              <b-dropdown-item
                v-if="$can('delete', 'learning-center-management')"
                @click="openDeleteModal(data.item)"
              >
                <feather-icon icon="TrashIcon" />
                <span class="align-middle ml-50">Delete Learning</span>
              </b-dropdown-item>
            </b-dropdown>
          </template>
        </b-table>
      </b-overlay>
    </b-card>
  </div>
</template>

<script>
import { ref } from '@vue/composition-api'
import {
  BTable, BCard, BOverlay, BDropdown, BDropdownItem, BButton,
} from 'bootstrap-vue'
import formatDate from '@/utils/date-format'
import useRegisterStoreModule from '@/hooks/useRegisterStoreModule'
import store from '../driverStoreModule'

import DeleteLearningCenterModal from './DeleteLearningCenterModal.vue'

export default {
  components: {
    BTable,
    BCard,
    BButton,
    DeleteLearningCenterModal,
    BOverlay,
    BDropdown,
    BDropdownItem,
  },
  setup(props, ctx) {
    useRegisterStoreModule('drivers', store)

    const tableColumns = [
      'title',
      'title_ar',
      'description',
      'description_ar',
      {
        key: 'sort_order',
        sortable: true,
      },
      {
        label: 'created at',
        key: 'created_at',
        formatter: val => formatDate(val),
      },
      'actions',
    ]

    const learnings = ref([])
    const loading = ref(false)
    const fetchLearnings = async () => {
      loading.value = true
      const result = await ctx.root.$store.dispatch('drivers/fetchLearnings')
      const { data } = result.data
      learnings.value = data
      loading.value = false
    }

    const toBeDeletedLearning = ref()
    const openDeleteModal = learning => {
      toBeDeletedLearning.value = learning
      ctx.root.$bvModal.show('delete-learning-modal')
    }
    fetchLearnings()

    return {
      sortDesc: ref(false),
      tableColumns,
      toBeDeletedLearning,
      loading,
      openDeleteModal,
      fetchLearnings,
      learnings,
    }
  },
}
</script>

      <style>

      </style>
